import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Input, Cascader, Select, DatePicker, Radio, Checkbox, Button, Icon, Tooltip } from 'antd';
import Text from '../../../basicElement/Text';
import RiskLevelTable from './RiskLevelTable';
import TokenActionOrPlan from './TokenActionOrPlan';
import SearchRetrieve from '../../../common/SearchRetrieve.new';
import { getMatchOption, generateOptions } from '../../../shared/selectFn';
import deepClone from '../../../shared/deepClone';
import format from '../../../shared/format';
import API_URL from '../../../../common/url';

const width = 240;
const paddingLeft = 19.891;
const longWidth = 700 + paddingLeft;
const { Option } = Select;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const Default = {
    0: '否',
    1: '是'
};

const defaultOption = generateOptions(Default, 'radio');

const formatToCascaderOption = (data) => {
    (data || []).forEach(item => {
        item.value = item.complaintConfigureId;
        item.label = item.optionValue;
        
        if (item.childList && item.childList.length > 0) {
            item.children = item.childList;
            formatToCascaderOption(item.children);
        }
    });
};

function UpdateView(props, context) {
    const { data, editable, onChange } = props;
    const { configure } = context;
    const { investigation = {} } = data;
    const {
        COMPLAINT_FROM = [],
        COMPLAINT_POSITION = [],
        AREA = [],
        COMPLAINT_TYPE = [],
        COMPLAINT_RISK = [],
        MAIN_RESPONSIBLE = [],
        JS_EMPLOYEE_RELEVANCE = [],
        PROCESS_INFO = [],
    } = configure;

    const handleChange = (value, key) => {
        switch (key) {
            case 'complaintFrom':
                data[key] = value;
                data.complaintFromRemark = undefined;
                break;
            case 'complaintPosition':
                data[key] = value;
                data.complaintPositionRemark = undefined;
                break;
            case 'complaintedUser': {
                const { value: id, text: name, leaderName, leaderCode } = value;
                data[`${key}Id`] = id;
                data[`${key}Name`] = name;
                data.leaderName = leaderName;
                data.leaderCode = leaderCode;
                break;
            }
            case 'investigation': {
                const { value: id, text: name } = value;
                data[`${key}Id`] = id;
                data[`${key}Name`] = name;
                data.investigation = value;
                data.investigationSiteId = '';
                data.investigationSiteName = '';
                break;
            }
            case 'investigationSite': {
                const { value: id, text: name } = value;
                data[`${key}Id`] = id;
                data[`${key}Name`] = name;
                break;
            }
            case 'complaintType': {
                const otherId = COMPLAINT_TYPE.filter(i => i.optionValue == '其他')[0].complaintConfigureId;
                if (
                    (value.includes(otherId) && !(data.complaintType || []).includes(otherId)) ||
                    (!value.includes(otherId) && (data.complaintType || []).includes(otherId))
                ) {
                    data.complaintTypeRemark = undefined;
                }
                data[key] = value;
                break;
            }
            case 'complaintMainResponsible': {
                const otherId = MAIN_RESPONSIBLE.filter(i => i.optionValue == '其他')[0].complaintConfigureId;
                if (
                    (value.includes(otherId) && !(data.complaintMainResponsible || []).includes(otherId)) ||
                    (!value.includes(otherId) && (data.complaintMainResponsible || []).includes(otherId))
                ) {
                    data.complaintMainResponsibleRemark = undefined;
                }
                data[key] = value;
                break;
            }
            default: {
                data[key] = value;
                break;
            }
        }
        onChange(data);
    };

    const handleAddTokenActionOrPlan = () => {
        const { data } = props;
        if (!data.complaintProcessPlanList) {
            data.complaintProcessPlanList = [];
        }
        data.complaintProcessPlanList.push({});
        onChange(data);
    };
    
    const complaintFromOption = COMPLAINT_FROM.map(i => <Option key={i.complaintConfigureId}>{i.optionValue}</Option>);
    const complaintPositionOption = deepClone(COMPLAINT_POSITION);
    const areaOption = AREA.filter(i => i.areaName !== '香港' && i.areaName !== '澳门' && i.areaName !== '台湾').map(i => <Option key={i.areaId}>{i.areaName}</Option>);
    const complaintTypeOption = COMPLAINT_TYPE.map(i => ({ value: i.complaintConfigureId, label: i.optionValue }));
    const riskLevelOption = COMPLAINT_RISK.map(i => <Radio key={i.complaintConfigureId} value={i.complaintConfigureId}>{i.optionValue}</Radio>);
    const complaintMainResponsibleOption = MAIN_RESPONSIBLE.map(i => ({ value: i.complaintConfigureId, label: i.optionValue }));
    const jsEmployeeRelevanceOption = JS_EMPLOYEE_RELEVANCE.map(i => <Radio key={i.complaintConfigureId} value={i.complaintConfigureId}>{i.optionValue}</Radio>);
    const processInfoOption = PROCESS_INFO.map(i => <Radio key={i.complaintConfigureId} value={i.complaintConfigureId}>{i.optionValue}</Radio>);
    
    formatToCascaderOption(complaintPositionOption);
    
    const showComplaintFromOther = getMatchOption(COMPLAINT_FROM, 'complaintConfigureId', data.complaintFrom).optionValue === '其他';
    const firstComplaintPositionChildren = getMatchOption(COMPLAINT_POSITION, 'complaintConfigureId', (data.complaintPosition || [])[0]).childList || [];
    const showComplaintPositionOther = getMatchOption(firstComplaintPositionChildren, 'complaintConfigureId', (data.complaintPosition || [])[1]).optionValue === '其他';
    const showComplaintTypeOther = (data.complaintType || []).some(i => getMatchOption(COMPLAINT_TYPE, 'complaintConfigureId', i).optionValue === '其他');
    const showComplaintMainResponsibleOther = (data.complaintMainResponsible || []).some(i => getMatchOption(MAIN_RESPONSIBLE, 'complaintConfigureId', i).optionValue === '其他');

    return (
        <div style={{ background: '#fafafa' }}>
            <div className="historyContractRecordUpdate">
                <Row>
                    <Col span={12}>
                        <Row>
                            <Col span={8}>
                                <Text asterisk={editable} colon={true}>投诉来源</Text>
                            </Col>
                            <Col span={15} offset={1}>
                                {
                                    editable ?
                                        <Select
                                            allowClear={true}
                                            placeholder="请选择"
                                            style={{width}}
                                            value={format('toString', data.complaintFrom)}
                                            onChange={value => handleChange(value, 'complaintFrom')}
                                        >
                                            {complaintFromOption}
                                        </Select>
                                    :
                                        data.complaintFromShow
                                }
                            </Col>
                        </Row>
                        {
                            (editable && showComplaintFromOther) &&
                            <Row>
                                <Col span={8}>
                                    <Text>&nbsp;</Text>
                                </Col>
                                <Col span={15} offset={1}>
                                    <Input
                                        placeholder="请填写其他备注"
                                        style={{width}}
                                        value={data.complaintFromRemark}
                                        onChange={e => handleChange(e.target.value, 'complaintFromRemark')}
                                    />
                                </Col>
                            </Row>
                        }
                    </Col>
                    <Col span={12}>
                        <Row>
                            <Col span={8}>
                                <Text asterisk={editable} colon={true}>投诉人职位</Text>
                            </Col>
                            <Col span={15} offset={1}>
                                {
                                    editable ?
                                        <Cascader
                                            allowClear={true}
                                            placeholder="请选择"
                                            style={{width}}
                                            options={complaintPositionOption}
                                            value={data.complaintPosition}
                                            onChange={value => handleChange(value, 'complaintPosition')}
                                        />
                                    :
                                        data.complaintPositionShow
                                }
                            </Col>
                        </Row>
                        {
                            (editable && showComplaintPositionOther) &&
                            <Row>
                                <Col span={8}>
                                    <Text>&nbsp;</Text>
                                </Col>
                                <Col span={15} offset={1}>
                                    <Input
                                        placeholder="请填写其他备注"
                                        style={{width}}
                                        value={data.complaintPositionRemark}
                                        onChange={e => handleChange(e.target.value, 'complaintPositionRemark')}
                                    />
                                </Col>
                            </Row>
                        }
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Col span={8}>
                            <Text asterisk={editable} colon={true}>被投诉人</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            {
                                editable ?
                                    <SearchRetrieve
                                        keyword='keyword'
                                        style={{ width }}
                                        params={{ limit: 20 }}
                                        placeholder="输入姓名/工号检索"
                                        value={data.complaintedUserName}
                                        url={API_URL.investigation.queryUserByKey}
                                        config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }}
                                        onChange={option => handleChange(option, 'complaintedUser')}
                                    />
                                :
                                    data.complaintedUserName
                            }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text asterisk={editable} colon={true}>事件发生的区域</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            {
                                editable ?
                                    <Select
                                        allowClear={true}
                                        placeholder="请选择"
                                        style={{width}}
                                        value={format('toString', data.happendAreaId)}
                                        onChange={value => handleChange(value, 'happendAreaId')}
                                    >
                                        {areaOption}
                                    </Select>
                                :
                                    data.areaName
                            }
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>直线主管</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { format('joint', data.leaderName, data.leaderCode) }
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Col span={4}>
                            <Text asterisk={editable} colon={true}>项目简称</Text>
                        </Col>
                        <Col span={20} style={{ paddingLeft }}>
                            {
                                editable ?
                                    <SearchRetrieve
                                        keyword='investigationName'
                                        style={{ width: longWidth }}
                                        params={{ limit: 20 }}
                                        placeholder="输入名称检索"
                                        value={data.investigationName}
                                        url={API_URL.investigation.queryInvestigationByName}
                                        config={{ id: 'investigationId', name: 'investigationName' }}
                                        onChange={option => handleChange(option, 'investigation')}
                                    />
                                :
                                    data.investigationName
                            }
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Col span={4}>
                            <Text colon={true}>项目名称</Text>
                        </Col>
                        <Col span={20} style={{ paddingLeft }}>
                            { investigation.investigationSpecialName }
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>项目编号</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.investigationCode }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>业务线</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.lineOfBusinessString }
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>执行业务线二级分类</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.secondLineNames }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>项目领域</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.investigationAreaName }
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>疾病</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.diseaseName }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>领域leader</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.leaderNameCode }
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>研究产品类型</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.investigationMedicineName }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>给药方式</Text>
                        </Col>
                        <Col span={15} offset={1}>
                           { investigation.administrationModeShow }
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>申办方</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.investigationSponsor }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>CRO</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.cro }
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Col span={8}>
                            <Text colon={true}>津石PM</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            { investigation.pmNames }
                        </Col>
                    </Col>
                    <Col span={12}>
                        <Col span={8}>
                            <Text asterisk={editable} colon={true}>涉及研究中心</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            {
                                editable ?
                                    <SearchRetrieve
                                        keyword='investigationSiteNameCode'
                                        style={{ width }}
                                        disabled={!data.investigationId}
                                        params={{ limit: 20, investigationId: data.investigationId }}
                                        placeholder="输入名称检索"
                                        value={data.investigationSiteName}
                                        url={API_URL.investigation.queryInvestigationSiteList}
                                        config={{ id: 'investigationSiteId', name: 'investigationSiteName', code: 'investigationSiteCode', type: 'investigationSite', show: 'site' }}
                                        onChange={option => handleChange(option, 'investigationSite')}
                                    />
                                :
                                    data.investigationSiteName
                            }
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={12}>
                        <Col span={8}>
                            <Text asterisk={editable} colon={true}>事件发生时间</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            {
                                editable ?
                                    <DatePicker
                                        style={{width}}
                                        allowClear={true}
                                        placeholder="请选择"
                                        value={format('toMoment', data.happendDate)}
                                        onChange={(date, dateString) => handleChange(dateString, 'happendDate')}
                                    />
                                :
                                    data.happendDate
                            }
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Col span={4}>
                            <Text asterisk={editable} colon={true}>投诉内容陈述</Text>
                        </Col>
                        <Col span={20} style={{ paddingLeft }}>
                            {
                                editable ?
                                    <CheckboxGroup options={complaintTypeOption} value={data.complaintType} onChange={value => handleChange(value, 'complaintType')} />
                                :
                                    data.complaintTypeName
                            }
                        </Col>
                    </Col>
                    {
                        (editable && showComplaintTypeOther) &&
                        <Col span={24}>
                            <Col span={4}>
                                <Text>&nbsp;</Text>
                            </Col>
                            <Col span={20} style={{ paddingLeft }}>
                                <Input
                                    placeholder="请填写其他备注"
                                    style={{width: longWidth}}
                                    value={data.complaintTypeRemark}
                                    onChange={e => handleChange(e.target.value, 'complaintTypeRemark')}
                                />
                            </Col>
                        </Col>
                    }
                </Row>
                <Row>
                    <Col span={24}>
                        <Col span={4} style={{ textAlign: 'right' }}>
                            <Tooltip placement="top" overlayClassName="riskLevelTip" title={<RiskLevelTable />}>
                                <a><Icon style={{ marginRight: 8, fontSize: '16px' }} type="info-circle" /></a>
                            </Tooltip>
                            <Text className="inlineBlock" asterisk={editable} colon={true}>投诉风险等级</Text>
                        </Col>
                        <Col span={20} style={{ paddingLeft }}>
                            {
                                editable ?
                                    <RadioGroup onChange={e => handleChange(e.target.value, 'riskLevelId')} value={data.riskLevelId}>
                                        { riskLevelOption }
                                    </RadioGroup>
                                :
                                    data.riskLevel
                            }
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Col span={4}>
                            <Text asterisk={editable} colon={true}>投诉可能造成的影响</Text>
                        </Col>
                        <Col span={20} style={{ paddingLeft }}>
                            {
                                editable ?
                                    <Input
                                        placeholder="请输入"
                                        style={{width: longWidth}}
                                        value={data.possibleImpact}
                                        onChange={e => handleChange(e.target.value, 'possibleImpact')}
                                    />
                                :
                                    data.possibleImpact
                            }
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Col span={4}>
                            <Text asterisk={editable} colon={true}>主要责任方</Text>
                        </Col>
                        <Col span={20} style={{ paddingLeft }}>
                            {
                                editable ?
                                    <CheckboxGroup options={complaintMainResponsibleOption} value={data.complaintMainResponsible} onChange={value => handleChange(value, 'complaintMainResponsible')} />
                                :
                                    data.mainResponsible
                            }
                        </Col>
                    </Col>
                    {
                        (editable && showComplaintMainResponsibleOther) &&
                        <Col span={24}>
                            <Col span={4}>
                                <Text>&nbsp;</Text>
                            </Col>
                            <Col span={20} style={{ paddingLeft }}>
                                <Input
                                    placeholder="请填写其他备注"
                                    style={{width: longWidth}}
                                    value={data.complaintMainResponsibleRemark}
                                    onChange={e => handleChange(e.target.value, 'complaintMainResponsibleRemark')}
                                />
                            </Col>
                        </Col>
                    }
                </Row>
                <Row>
                    <Col span={24}>
                        <Col span={4}>
                            <Text asterisk={editable} colon={true}>与津石员工相关性</Text>
                        </Col>
                        <Col span={20} style={{ paddingLeft }}>
                            {
                                editable ?
                                    <RadioGroup onChange={e => handleChange(e.target.value, 'jsEmployeeRelevanceId')} value={data.jsEmployeeRelevanceId}>
                                        { jsEmployeeRelevanceOption }
                                    </RadioGroup>
                                :
                                    data.jsEmployeeRelevance
                            }
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Col span={4}>
                            <Text asterisk={editable} colon={true}>已采取的措施或计划</Text>
                        </Col>
                        <Col span={19} style={{ paddingLeft }}>
                            { editable && <Button type="ghost" style={{ marginBottom: 10 }} onClick={handleAddTokenActionOrPlan}>添加</Button> }
                            <TokenActionOrPlan
                                canEdit={editable}
                                data={data.complaintProcessPlanList || []}
                                onChange={value => handleChange(value, 'complaintProcessPlanList')}
                            />
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Col span={4}>
                            <Text asterisk={editable} colon={true}>投诉事件处理结束与否</Text>
                        </Col>
                        <Col span={20} style={{ paddingLeft }}>
                            {
                                editable ?
                                    <RadioGroup onChange={e => handleChange(e.target.value, 'processInfoId')} value={data.processInfoId}>
                                        { processInfoOption }
                                    </RadioGroup>
                                :
                                    data.processInfoName
                            }
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Col span={4}>
                            <Text colon={true}>最终处理情况及影响</Text>
                        </Col>
                        <Col span={20} style={{ paddingLeft }}>
                            {
                                editable ?
                                    <Input
                                        placeholder="请输入"
                                        style={{width: longWidth}}
                                        value={data.processImpactInfo}
                                        onChange={e => handleChange(e.target.value, 'processImpactInfo')}
                                    />
                                :
                                    data.processImpactInfo
                            }
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Col span={4}>
                            <Text asterisk={editable} colon={true}>是否已在重大事件登记</Text>
                        </Col>
                        <Col span={20} style={{ paddingLeft }}>
                            {
                                editable ?
                                    <RadioGroup onChange={e => handleChange(e.target.value, 'isMajorEvent')} value={format('toString', data.isMajorEvent)}>
                                        { defaultOption }
                                    </RadioGroup>
                                :
                                    data.isMajorEventShow
                            }
                        </Col>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

UpdateView.contextTypes = {
    configure: PropTypes.object
};

export default UpdateView;


// WEBPACK FOOTER //
// ./src/components/qualityManagement/ComplaintRegistrationForm/components/UpdateView.js